/**
 *
 * Created Date: 2019-07-03, 23:16:21 (zhenliang.sun)
 * Last Modified: 2019-08-08, 18:24:06 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * 用来过滤pageData中无效数据的
 *
 * @export
 * @class Filter
 * @author zhenliang.sun
 */
export default class Filter {
  constructor() {}

  /**
   * 根据数据内容，筛选出执行的页码和步骤，还有对应的画笔操作
   *
   * @param {*} arr
   * @memberof Filter
   * @returns Array
   */
  exec(arr) {
    if (arr.length === 0) {
      return [];
    }

    let stepData = null;
    let result = [];

    while (arr.length) {
      let item = arr.shift();
      // 如果没有hash  可能是 创建、点选
      if (item['hash'] === '') {
        continue;
      }

      let commands = item['command'] || [];
      if (commands.length === 0) {
        continue;
      }

      let command = commands[0];

      // 忽略准备好
      if (command['event'] === 'ready') {
        continue;
      }

      // 如果是步数更新，开始覆盖式记录最后一条, 因为后台返回数据，按照uniqueID进行排序了。 所以只取最后一条即可
      if (command['event'] === 'onStepChange') {
        // stepData = item
        continue;
      }

      result.push(item);
    }

    // 把最后一个翻步消息追加到数据头部
    if (stepData) {
      result.unshift(stepData);
    }

    return result;
  }

  execBoard(arr) {
    if (arr.length === 0) {
      return [];
    }

    let result = [];

    while (arr.length) {
      let item = arr.shift();

      let commands = item['command'] || [];
      if (commands.length === 0) {
        continue;
      }

      let command = commands[0];

      if (command['type'] === '*remove_all') {
        result = [];
      }

      result.push(item);
    }

    return result;
  }
}
